import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Paragraph from '@features/_common/components/Paragraph/Paragraph';
import { Button } from '@common/components';
import { Link } from 'react-router-dom';
import CookiesHandler from '@features/_common/utils/CookiesHandler';
import { COOKIES } from '@features/cookies/routes';
import PropTypes from 'prop-types';
import style from './CookiesBanner.module.scss';

export default function CookiesBanner({ isFooterVisible }) {
  const { t } = useTranslation('cookies\\CookiesBanner');
  const cookiesHandler = new CookiesHandler();

  const [visible, setVisible] = useState(true);

  useEffect(() => {
    cookiesHandler.initThirdPartyCookies();
    if (cookiesHandler.isAllowCookies() !== undefined) {
      setVisible(false);
    }
  }, []);

  const handleAccept = () => {
    cookiesHandler.acceptCookies();
    setVisible(false);
  };

  const handleReject = () => {
    cookiesHandler.rejectCookies();
    setVisible(false);
  };

  if (visible) {
    return (
      <section
        className={`${style.section} ${
          !isFooterVisible ? style.no_footer : ''
        }`}
      >
        <Paragraph
          title={t('cookieBannerCookiesPolicy')}
          text={t('cookieBannerText')}
          className={style.paragraph}
        />
        <section className={style.button_section}>
          <Button
            className={style.accept_button}
            onClick={handleAccept}
            variant="raised"
            color="secondary"
          >
            {t('cookieBannerAcceptButton')}
          </Button>
          <Button
            className={style.reject_button}
            onClick={handleReject}
            variant="raised"
            color="secondary"
          >
            {t('cookieBannerRejectButton')}
          </Button>
          <Link className={style.policy_link} href={COOKIES}>
            {t('cookieBannerCookiesPolicy')}
          </Link>
        </section>
      </section>
    );
  }
}

CookiesBanner.propTypes = {
  isFooterVisible: PropTypes.bool.isRequired,
};
